import { StudyDataType } from "@/types/apiTypes";
import { getToken } from "@/utils/authHelpers";
import axios from "axios";
import { API_BASE_URL } from "@/utils/api";

export const removeStudyFromProjectAPI = async (
  study: StudyDataType,
  selectedProjectId: string | null,
): Promise<void> => {
  const token = await getToken();
  if (!token) {
    throw new Error("Authorization token is required");
  }

  try {
    await axios.delete(
      `${API_BASE_URL}/projects/${selectedProjectId}/studies/${study.id}`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
  } catch (error) {
    console.error("Failed to remove study from project", error);
    throw error;
  }
};
